import React, { useEffect } from "react";
import aboutUs from "../assets/img/about-us.png";
import aboutVegetables from "../assets/img/about-vegetables.png";

const About = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<div className="bg-gray-50">
			<div className="flex justify-center py-10 lg:py-20 bg-page-header-bg bg-brand-100 w-full bg-cover bg-no-repeat bg-bottom bg-page-header ">
				<div className="flex mx-auto w-full max-w-screen-2xl px-3 sm:px-10">
					<div className="w-full flex justify-center flex-col relative">
						<h2 className="text-xl md:text-3xl lg:text-4xl font-bold text-center text-black">
							About US
						</h2>
					</div>
				</div>
			</div>
			<div className="bg-white">
				<div className="max-w-screen-2xl mx-auto lg:py-20 py-10 px-4 sm:px-10">
					<div className="grid grid-flow-row lg:grid-cols-2 gap-4 lg:gap-16 ">
						<div>
							<h3 className="text-xl lg:text-3xl mb-2  font-semibold">
								About Us – WholesaleDai.com
							</h3>
							<div className="mt-3 text-base opacity-90 leading-7">
								<p className="mb-4">
									Welcome to WholesaleDai.com, Nepal's leading B2B marketplace, designed to bridge businesses, wholesalers, and suppliers for seamless bulk trade. We empower businesses across Nepal by providing a reliable, efficient, and cost-effective platform to source products, streamline procurement, and build meaningful partnerships.
								</p>

								<p className="mb-4">
									At WholesaleDai.com, we believe in making wholesale purchasing easier. Whether you're a retailer looking for inventory, a manufacturer seeking bulk buyers, or a distributor expanding your reach, our marketplace is built to serve your needs.
								</p>

								<p>
									With a vast network of trusted suppliers, transparent transactions, and a commitment to quality, WholesaleDai.com transforms traditional business buying into a smarter, more accessible digital experience. Join us in reshaping the way Nepal does business—one deal at a time.
								</p>
							</div>
							<div className="mt-4 text-lg font-semibold text-brand-600">
								Let's grow together!
							</div>
							<div className="grid md:grid-cols-2 gap-6 lg:grid-cols-2 xl:gap-6 mt-8">
								<div className="p-8 bg-brand-50 shadow-sm rounded-lg">
									<span className="text-3xl block font-extrabold  mb-4 text-gray-800">
										1000+
									</span>
									<h4 className="text-lg font-bold mb-1">Active Suppliers</h4>
									<p className="mb-0 opacity-90 leading-7">
										Trusted suppliers across Nepal offering quality products.
									</p>
								</div>
								<div className="p-8 bg-brand-50 shadow-sm rounded-lg">
									<span className="text-3xl block font-extrabold  mb-4 text-gray-800">
										5000+
									</span>
									<h4 className="text-lg  font-bold mb-1">Business Customers</h4>
									<p className="mb-0 opacity-90 leading-7">
										Growing network of satisfied business buyers nationwide.
									</p>
								</div>
							</div>
						</div>
						<div className="mt-10 lg:mt-0 ">
							<span
								style={{
									boxSizing: 'border-box',
									display: 'inline-block',
									overflow: 'hidden',
									width: 'initial',
									height: 'initial',
									background: 'none',
									opacity: '1',
									border: '0',
									margin: '0',
									padding: '0',
									position: 'relative',
									maxWidth: '100%',
								}}
							>
								<img
									alt="aboutus"
									style={{
										display: 'block',
										maxWidth: '100%',
										width: 'initial',
										background: 'none',
										opacity: '1',
										border: '0',
										margin: '0',
										padding: '0',
									}}
									src={aboutUs}
								/>
							</span>
						</div>
					</div>
					<div className="mt-10 lg:mt-16 text-base opacity-90 leading-7">
						<p className="mb-4">
							At WholesaleDai.com, we understand the challenges businesses face in sourcing quality products at competitive prices. Our platform is designed to eliminate these pain points by providing a direct connection between suppliers and buyers. We leverage cutting-edge technology to create a seamless, transparent, and efficient marketplace that serves businesses across Nepal.
						</p>
						<p>
							Our commitment to excellence extends beyond just connecting buyers and sellers. We actively work to ensure quality control, reliable delivery, and exceptional customer service. By digitalizing the wholesale buying process, we're helping businesses save time, reduce costs, and focus on what matters most - growing their business. Whether you're a small retailer or a large distributor, WholesaleDai.com is your trusted partner in business growth.
						</p>
					</div>
					<div className="mt-10 lg:mt-12 flex flex-col sm:grid gap-4">
						<span
							style={{
								boxSizing: 'border-box',
								display: 'inline-block',
								overflow: 'hidden',
								width: 'initial',
								height: 'initial',
								background: 'none',
								opacity: '1',
								border: '0',
								margin: '0',
								padding: '0',
								position: 'relative',
								maxWidth: '100%',
							}}
						>
							<span
								style={{
									boxSizing: 'border-box',
									display: 'block',
									width: 'initial',
									height: 'initial',
									background: 'none',
								}}
							>
								<img
									alt="aboutus"
									style={{
										display: 'block',
										maxWidth: '100%',
										width: 'initial',
										height: 'initial',
										background: 'none',
										opacity: '1',
										border: '0',
										margin: '0',
										padding: '0',
										boxSizing: 'border-box',
									}}
									className="block rounded-lg"
									src={aboutVegetables}
								/>
							</span>
						</span>
					</div>
				</div>
			</div>
		</div>
	);
}

export default About;
